module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921054149_T.222c61de.jpg";